import UserSocket from "../../sockets/user-socket";
import ROOMS from "../actions/rooms/types";
import LOBBY from "../actions/lobby/types";
import {omitBy} from "../../utils/index.js";

const roomInitialData = {
    roomId: null,
    status: null,
    playerId: null,
    opponentId: null,
    conventions: [],
    canJoin: false,
    joinRequest: false,
    modal: {},
    round: {},
    selectedCombinationCards: {},
    cardsSelectable: false,
    cardsChanged: false,
    timers: {},
    closeRoomModal: false,
}
const reducer = (state = {}, action) => {
        const socket = UserSocket.debouncedEmit.bind(UserSocket);
        switch (action?.type) {
            case ROOMS.ROOM_ENTER:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...roomInitialData,
                        ...action.payload
                    }
                }

            case ROOMS.ROOM_EXIT:
                   const currentState = omitBy(state, (value) => {
                    return value && typeof value === 'object' && value.roomId === action.payload.roomId
                })
                return {
                    ...currentState,
                }

            case ROOMS.ROOM_CLOSE:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state


            case ROOMS.RESTORE_ENTERED_ROOMS:
                const restoredRooms = {};
                Object.values(action.payload.enteredRooms).forEach(room => {
                    restoredRooms[room.roomId] = {
                        ...roomInitialData,
                        ...room
                    }
                })
                return {
                    ...restoredRooms
                }

            case ROOMS.ROOM_REJECT_OPPONENT:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state

            case ROOMS.ROOM_ACCEPT_OPPONENT:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state

            case ROOMS.ROOM_UPDATE:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        ...action.payload,
                    }
                }

            case ROOMS.ROOM_OPEN_CLOSE_MODAL:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        closeRoomModal: true,
                        notifier: false,
                    }
                }

            case ROOMS.ROOM_CLOSE_ROOM_MODAL:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        closeRoomModal: false,
                    }
                }

            case ROOMS.ROOM_FINISHED:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        modal: action.payload.modal,
                        round: action.payload.round,
                        status: action.payload.status,
                        isVisibleRoom: action.payload.isVisibleRoom,
                        joinRequest: false,
                        closeRoomModal: false,
                        notifier: false
                    }
                }

            case ROOMS.ROOM_ACCEPT_TRUMP:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state;

            case ROOMS.ROOM_REJECT_TRUMP:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state;

            case ROOMS.ROOM_PLAY_CARD:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state

            case ROOMS.ROOM_ANNOUNCE_COMBINATION:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state

            case ROOMS.ROOM_OPEN_MODAL:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        modal: {
                            isActive: true,
                            name: action.payload.name,
                            msg: action.payload.msg,
                        }
                    }
                }

            case ROOMS.ROOM_CLOSE_MODAL:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        modal: {}
                    }
                }

            case ROOMS.ROOM_ANNOUNCE_COMBINATION_FAILED:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        ...action.payload
                    }
                }

            case ROOMS.ROOM_ANNOUNCE_COMBINATION_RANK:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state

            case ROOMS.ROOM_ANNOUNCE_COMBINATION_RANK_FAILED:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        ...action.payload
                    }
                }

            case ROOMS.ROOM_PUBLISH_COMBINATION:
                socket(ROOMS.EVENT, {
                    action: action.type, payload: {
                        ...action.payload,
                        selectedCombinationCards: state[action.payload.roomId].selectedCombinationCards,
                        cardsChanged: state[action.payload.roomId].cardsChanged
                    },
                    ctx: 'Rooms'
                })
                return state

            case ROOMS.ROOM_PUBLISH_COMBINATION_FAILED:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        ...action.payload
                    }
                }

            case ROOMS.ROOM_SET_CARDS_SELECTABLE:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        cardsSelectable: action.payload.selectable
                    }
                }

            case ROOMS.ROOM_RESET_SELECTED_COMBINATION_CARDS:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        selectedCombinationCards: {},
                        cardsSelectable: false,
                        modal: {}
                    }
                }

            case ROOMS.ROOM_GET_COMBINATION_CARDS:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state

            case ROOMS.ROOM_SET_COMBINATION_CARDS:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        ...action.payload,
                        cardsChanged: false,
                        cardsSelectable: true,
                    }
                }

            case ROOMS.ROOM_SELECT_COMBINATION_CARD:
                let room = state[action.payload.roomId]
                const cards = room['selectedCombinationCards'] ? {...room['selectedCombinationCards']} : {};
                if (cards[action.payload.card.name]) {
                    delete cards[action.payload.card.name]
                } else {
                    cards[action.payload.card.name] = action.payload.card
                }
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        cardsChanged: true,
                        selectedCombinationCards: cards
                    }
                }

            case ROOMS.ROOM_ANNOUNCE_ALL_CARDS_TO_OPPONENT:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state;

            case ROOMS.ROOM_REQUEST_ALL_CARDS_TO_ME:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state;

            case ROOMS.ROOM_ACCEPT_ALL_CARDS_TO_ME_REQUEST:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state;

            case ROOMS.ROOM_REJECT_ALL_CARDS_TO_ME_REQUEST:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'});
                return state;

            case ROOMS.ROOM_RESET_ROUND:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        round: {
                            ...state[action.payload.roomId].round,
                            resetHand: true
                        }
                    }
                }

            case ROOMS.ROOM_UPDATE_TIMER:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        timers: action.payload
                    }
                }

            case ROOMS.ROOM_LEAVE_WAITING_ROOM:
                socket(LOBBY.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'})
                return state

            case ROOMS.ROOM_JOIN_TO_VIEW:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'})
                return state

            case ROOMS.ROOM_EXIT_FROM_VIEW:
                socket(ROOMS.EVENT, {action: action.type, payload: action.payload, ctx: 'Rooms'})
                return state

            case ROOMS.ROOM_SET_TAB_NOTIFIER:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        notifier: true,
                    }
                }

            case ROOMS.ROOM_UNSET_TAB_NOTIFIER:
                return {
                    ...state,
                    [action.payload.roomId]: {
                        ...state[action.payload.roomId],
                        notifier: false,
                    }
                }
            case ROOMS.CLEAN_UP_HISTORY_ROOMS:
                const updatedState = omitBy(state, (value) => {
                    return value && typeof value === 'object' && 'historyRoomPlayer' in value
                })
                return {
                    ...updatedState
                }

            default:
                return state;
        }
    }
;
export default reducer;
